import { getPath } from '@/router/common'

const baseUrl = {
  title: '工单中心',
  path: 'WorkOrderCenter'
}

export default [
    {
      path: getPath('Index', baseUrl),
      name: 'WorkOrderCenter_Index',
      component: () => import(/* webpackChunkName: "WorkOrderCenter_Index" */ '@/views/workOrderCenter/index/index.vue'),
      meta: {
        title: '工单中心'
      }
    },
    {
        path: getPath('Dialoag', baseUrl),
        name: 'WorkOrderCenter_Dialoag',
        component: () => import(/* webpackChunkName: "WorkOrderCenter_Dialoag" */ '@/views/workOrderCenter/dialoag/index.vue'),
        meta: {
          title: '官方客服快速服务'
        }
    },
    {
        path: getPath('SubmitOrder', baseUrl),
        name: 'WorkOrderCenter_Submit',
        component: () => import(/* webpackChunkName: "WorkOrderCenter_Submit" */ '@/views/workOrderCenter/submitOrder/index.vue'),
        meta: {
          title: '提交工单'
        }
    },
]